(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["collection-description-read-more"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('read-more-description')) {
    class ReadMoreDescription extends HTMLElement {
      connectedCallback() {
        this.content = this.querySelector('.rm-desc__content');
        this.button = this.querySelector('.rm-desc__toggle');
        if (!this.content || !this.button) return;

        this.button.addEventListener('click', () => this.toggle());
        this.observer = new ResizeObserver(() => this.update());
        this.observer.observe(this.content);
        this.update();
      }

      disconnectedCallback() {
        this.observer?.disconnect();
      }

      get expanded() {
        return !this.content.hasAttribute('data-collapsed');
      }

      // Knop enkel tonen als de tekst effectief langer is dan X lijnen
      update() {
        if (this.expanded) return;
        const overflows = this.content.scrollHeight > this.content.clientHeight + 1;
        this.button.hidden = !overflows;
      }

      toggle() {
        const expand = !this.expanded;
        this.content.toggleAttribute('data-collapsed', !expand);
        this.button.setAttribute('aria-expanded', String(expand));
        this.button.textContent = expand
          ? this.button.dataset.labelLess
          : this.button.dataset.labelMore;

        if (!expand) {
          // Bij inklappen terugscrollen als de beschrijving buiten beeld viel
          const top = this.getBoundingClientRect().top;
          if (top < 0) this.scrollIntoView({ block: 'start', behavior: 'smooth' });
        }
      }
    }
    customElements.define('read-more-description', ReadMoreDescription);
  }
  } catch(e) { console.error(e); }
})();

})();
